var React = require('react');

function ArrowDownGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 4.666V26.89M23.778 19.11 16 26.89 8.223 19.11","stroke":"#989CA7","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowDownGrey.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowDownGrey;

ArrowDownGrey.default = ArrowDownGrey;
